import {Directive, HostListener} from "@angular/core";
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from "@angular/forms";

@Directive({
	selector: "[appCommaDecimalPattern]",
	providers: [{provide: NG_VALIDATORS, useExisting: CommaDecimalPatternDirective, multi: true}],
})
export class CommaDecimalPatternDirective implements Validator {
	private regex: RegExp = /^\d+(,\d{1,2})?$/;
	private allowedNumbers: string[] = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ","];

	validate(control: AbstractControl): ValidationErrors | null {
		const value = control.value;
		if (value && !this.regex.test(value)) {
			return {commaDecimalPattern: true};
		}
		return null;
	}

	@HostListener("keypress", ["$event"])
	onKeyPress(event: KeyboardEvent) {
		if (!this.allowedNumbers.includes(event.key)) {
			event.preventDefault();
		}
	}

	@HostListener("paste", ["$event"])
	onPaste(event: ClipboardEvent) {
		const pastedText = event.clipboardData.getData("text");
		for (let pastedTextChar of pastedText) {
			if (!this.allowedNumbers.includes(pastedTextChar)) {
				event.preventDefault();
				break;
			}
		}
	}
}
